import { createAction } from '@reduxjs/toolkit';

export const setArticlesFilter = createAction('setArticlesFilter');
export const resetArticlesFilter = createAction('resetArticlesFilter');
